import React, { useState, useEffect } from "react";
import "./SkillIndexCircle.css";
import { Typography } from "antd";

export default function SkillIndexCircle(props) {
  const { Text } = Typography;
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  return (
    <div
      className="circleContainer"
      style={{
        height: props.cSize + "px",
        width: props.cSize + "px",
        borderRadius: props.cRadius + "%",
        backgroundColor: props.color,
        zIndex: props.zindex,
      }}
    >
      <Text className="textName">{props.name}</Text>
      <Text className="textPercent">{props.percent}</Text>
    </div>
  );
}
